module.exports = __webpack_public_path__ + "img/gold_slot_ka.dd97c4d2.png";